// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/index'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../theme/index.css'
import api from './api'
import store from './store/store'
import axios from 'axios'
import $ from 'jquery'
import fliter from './api/filter'
import utils from './utils/utils';
import qs from 'qs'
import global_variable from '../global_variable'
Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.GLOBAL=global_variable
Vue.prototype.$=$;
Vue.prototype.$utils=utils;
String.prototype.replaceAll = function(s1, s2) {
  return this.replace(new RegExp(s1, "gm"), s2);
}
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js